export interface FSUser {
  brokerID: string;
  firstName: string;
  lastName: string;
  email: string;
}

export interface User extends FSUser {
  id: string;
}

export const MOCK_USER: User = {
  id: 'a9gzGYUPUDR440j2pleOqtfNJHn2',
  brokerID: 'a9gzGYUPUDR440j2pleOqtfNJHn2',
  firstName: 'John',
  lastName: 'Doe',
  email: 'john.doe@gmail.com',
};
